import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=6d349d96&"
import script from "./SearchComponent.ts?vue&type=script&lang=ts&"
export * from "./SearchComponent.ts?vue&type=script&lang=ts&"
import style0 from "./SearchComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SearchComponent.vue"
export default component.exports